import store from '@/store/index';
import { store as localStorage } from '@/utils/common';
import { tsNow } from '@/utils/timeSync';

/*
 * Handles Gelf Logging
 * Send logs individually if socket is connected
 * If not, store logs temporarily on local storage for later sending
 */
export default class GelfLogger {
  log(newLogInfo, callback, emitFn) {
    const socket = store.state.socketio.socket;
    const lessonId = store.state.lessonId;

    const existingLogs = Array.isArray(localStorage.getLog(lessonId))
      ? localStorage.getLog(lessonId)
      : [];
    
    newLogInfo = { ...newLogInfo, ts: tsNow() }

    const allLogs = [newLogInfo, ...existingLogs];

    if (!socket?.connected) {
      localStorage.addLog(lessonId, allLogs);
      callback?.(null, null);
    } else {
      localStorage.emptyLog(lessonId);
      socket?.emit('gelf-log', allLogs);
      callback?.(null, true);
    }

    emitFn?.('logged', newLogInfo);
  }
}
